// extracted by mini-css-extract-plugin
export var card = "Column-module--card--d92c8";
export var cards = "Column-module--cards--b7e3d";
export var container = "Column-module--container--3da3f";
export var label = "Column-module--label--9dcfa";
export var sectionLabel = "Column-module--sectionLabel--97690";